export interface PainPoint {
  title: string
  description: string
}

export const painPoints: PainPoint[] = [
  {
    title: "I've Never Played Lacrosse",
    description:
      'You were handed a team because nobody else put their hand up. You are learning the sport one week ahead of the girls.',
  },
  {
    title: 'No Time to Plan',
    description:
      'You find out on Tuesday night what you are running on Wednesday. Every session gets improvised on the drive over.',
  },
  {
    title: 'The Rules Terrify Me',
    description:
      'Shooting space, the sphere, the 8-meter. One wrong call in front of a referee or a parent and you feel completely exposed.',
  },
]
